import Vue from 'vue'
import 'jquery-slimscroll'
import classlist from 'util/classlist';
import mask from 'components/global/Loading';
var Mask = Vue.extend(mask);

export default {
	install(Vue) {
		//console.log(this.$store)
		Vue.directive('focus', {
				inserted: function(el,binding) {
					if(binding.value){
						el.focus()
					}
				}
			}),
			Vue.directive('img', {
				inserted: function(el, binding) {
					var color = Math.floor(Math.random() * 1000000);
					el.style.backgroundColor = '#' + color;
				}
			}),
			Vue.directive('slimScroll',{
				inserted:function(el,binding){
					$(el).slimScroll(binding.value)
				}
			}),
			Vue.directive('metisMenu',{
				inserted:function(el,binding){
					$(el).metisMenu()
				}
			}),
			Vue.directive('loading', {
			    bind: function(el, binding) {
			      let mask = new Mask({
			        el: document.createElement('div'),
			        data: {
			          text: el.getAttribute('element-loading-text'),
			          fullscreen: !!binding.modifiers.fullscreen,
			          radius:el.getAttribute('element-loading-radius') || 20
			        }
			      });
			      el.instance = mask;
			      el.mask = mask.$el;
			      el.maskStyle = {};
	
			      toggleLoading(el, binding);
			    },
			    update: function(el, binding) {
			      if (binding.oldValue !== binding.value) {
			        toggleLoading(el, binding);
			      }
			    },
			    unbind: function(el, binding) {
			      if (el.domInserted) {
			        if (binding.modifiers.fullscreen || binding.modifiers.body) {
			          document.body.removeChild(el.mask);
			        } else {
			          el.mask &&
			          el.mask.parentNode &&
			          el.mask.parentNode.removeChild(el.mask);
			        }
			      }
			    }	
			})
	}
}

/**
 * 等待加载页面创建方法
 */
function toggleLoading(el, binding) {
    if (binding.value) {
      Vue.nextTick(() => {
        if (binding.modifiers.fullscreen) {
          el.originalPosition = document.body.style.position;
          el.originalOverflow = document.body.style.overflow;

          classlist.addClass(el.mask, 'is-fullscreen');
          insertDom(document.body, el, binding);
        } else {
          classlist.removeClass(el.mask, 'is-fullscreen');

          if (binding.modifiers.body) {
            el.originalPosition = document.body.style.position;

            ['top', 'left'].forEach(property => {
              let scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
              el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
            });
            ['height', 'width'].forEach(property => {
              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
            });

            insertDom(document.body, el, binding);
          } else {
            el.originalPosition = el.style.position;
            insertDom(el, el, binding);
          }
        }
      });
    } else {
      if (el.domVisible) {
        el.instance.$on('after-leave', _ => {
          el.domVisible = false;
          if (binding.modifiers.fullscreen && el.originalOverflow !== 'hidden') {
            document.body.style.overflow = el.originalOverflow;
          }
          if (binding.modifiers.fullscreen || binding.modifiers.body) {
            document.body.style.position = el.originalPosition;
          } else {
            el.style.position = el.originalPosition;
          }
        });
        el.instance.visible = false;
      }
    }
};

/**
 * 等待加载页面插入到DOM
 */
function insertDom(parent, el, binding) {
    if (!el.domVisible) {
      Object.keys(el.maskStyle).forEach(property => {
        el.mask.style[property] = el.maskStyle[property];
      });

      if (el.originalPosition !== 'absolute') {
        parent.style.position = 'relative';
      }
      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
        parent.style.overflow = 'hidden';
      }
      el.domVisible = true;

      parent.appendChild(el.mask);
      Vue.nextTick(() => {
        el.instance.visible = true;
      });
      el.domInserted = true;
    }
};


// WEBPACK FOOTER //
// ./src/static/directive.js